// extracted by mini-css-extract-plugin
export default {"closingIcon":"ClosingIcon_closingIcon__Z4WYC"};